import { Link } from 'react-router-dom'
import RemoveRelatedpatient from './RemoveRelatedPatient'
import { formatPatientName } from '../../../../lib/patientName'

import classes from './FindRelatedChusaPatient.module.css'

export default function ChusaRelatedPatient({items}) {
    
    return <div className={classes.related_patients}>
        {items && items.map(item => (
            <div key={item.id} className={classes.item}>
                <div>
                    <Link to={`../${item.id}`} className={classes.item_link}>
                        <div className={classes.name}>{formatPatientName(item, { order: 'lastFirst' })}</div>                    
                    </Link>
                    <div className={classes.case}>NG{item.person_number}</div>
                </div>
                
                <RemoveRelatedpatient id={item.id}/>
            </div>
        ))}
    </div>
}